import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import hero from "../../images/haytext.png";

const Hero = () => {
    return (
        <div className="hero flex flex-col items-center justify-center text-center gap-y-10 md:gap-y-6 px-6 sm:px-10 md:px-20 lg:px-32 py-12 overflow-hidden">
            {/* Image */}
            <motion.img
                src={hero}
                alt="Haystack illustration"
                className="h-36 sm:h-40 md:h-48 lg:h-56 xl:h-60 object-contain"
                initial={{ opacity: 0, y: -40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
            />

            {/* Date heading */}
            <motion.h1
                className="font-clashRegular text-white text-2xl sm:text-3xl md:text-4xl tracking-wide"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3, duration: 0.8, ease: "easeOut" }}
            >
                30TH  SEPT  -  4TH  OCT,   2026
            </motion.h1>

            {/* Description */}
            <motion.p
                className="text-white font-inter text-left tracking-wide leading-loose xs:leading-relaxed text-sm max-w-md md:max-w-2xl"
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6, duration: 0.9, ease: "easeOut" }}
            >
                This year, we build another haystack monument that will commemorate
                the birth of greater moves of God across the world as we usher in
                mighty harvests across the globe through prayers and as more hearts
                are set on fire.
            </motion.p>

            {/* Register button */}
            <motion.div
                className="mt-4"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.9, duration: 0.6, ease: "easeOut" }}
            >
                <a
                    href="#haystack"
                    className="bg-greenY px-8 sm:px-10 lg:px-12 py-2.5 sm:py-3 rounded-lg font-inter font-semibold text-sm sm:text-base lg:text-lg text-black shadow-md hover:bg-greenY/80 transition-colors"
                >
                    REGISTER
                </a>
            </motion.div>
        </div>
    );
};

export default Hero;
